import { environment } from '@/env/environment';

/**
 * Solo el dominio público de producción se deja indexar. Dev y QA se
 * compilan con `production: true`, así que se distingue por el host de
 * `baseUrl` y no por esa bandera.
 */
const INDEXABLE_HOSTS: readonly string[] = ['alamo.com.mx', 'www.alamo.com.mx'];

export const ROBOTS_NOINDEX = 'noindex, nofollow';

export function isIndexableHost(baseUrl: string = environment.baseUrl): boolean {
    try {
        return INDEXABLE_HOSTS.includes(new URL(baseUrl).hostname);
    } catch {
        return false;
    }
}
